module.exports = __webpack_public_path__ + "img/fleet-yellow.06a7722a.svg";